// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import { yupResolver } from '@hookform/resolvers/yup'
import axios from 'axios'
import { SubText, TitleH2 } from 'components/Common/Typography'
import Router, { useRouter } from 'next/router'
import { FC, useEffect, useState } from 'react'
import { Button, Col, Container, Form, Row, Spinner } from 'react-bootstrap'
import { Controller, SubmitHandler, useForm } from 'react-hook-form'
import PhoneInput, { isValidPhoneNumber } from 'react-phone-number-input'
import * as yup from 'yup'

type FormValues = {
  yourName: string
  yourEmail: string
  phoneInput: string
  skypeID: string
  projectRequirements: string
}
const schema = yup.object().shape({
  yourName: yup.string().max(80).trim().required('Your Name is required'),
  yourEmail: yup
    .string()
    .email('Invalid email format')
    .max(255)
    .required('Your Email is required'),
  projectRequirements: yup
    .string()
    .trim()
    .required('Your Project Requirements is required'),
  phoneInput: yup
    .string()
    .test('isValidPhoneNumber', 'Invalid phone number', (value) =>
      value ? isValidPhoneNumber(value) : true
    ),
})
const ContactUsAzureSection: FC<{ data: any }> = ({ data }) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    control,
  } = useForm<FormValues>({
    resolver: yupResolver(schema),
  })

  const [SuccessMesg, setSuccessMesg] = useState('')
  const [ErrorMesg, setErrorMesg] = useState('')
  const [Loading, setLoading] = useState(false)
  const router = useRouter()

  const PageUrl = router.query.path
    ? router.query.path
    : router.pathname.split('/')[1]

  const [phoneCountryCode, setPhoneCountryCode] = useState()
  const [formCountryName, setFromCountryName] = useState()

  const onSubmit: SubmitHandler<FormValues> = async (dataFetch) => {
    setLoading(true)
    setSuccessMesg('')
    setErrorMesg('')

    const newComment = {
      name: dataFetch.yourName,
      email: dataFetch.yourEmail,
      skypeId: '',
      contactNumber: dataFetch.phoneInput,
      pro_requirements: dataFetch.projectRequirements,
      pageName: PageUrl,
      countryName: formCountryName,
    }
    try {
      const result = await axios.post(
        `${process.env.NEXT_PUBLIC_API_URL}/api/user/contactUs/sendInquiry`,
        newComment,
        {
          headers: {
            web_id: 'webcluesinfotech',
          },
        }
      )

      if (result.data.code === 200) {
        setLoading(false)
        setSuccessMesg('Thank you for your message. It has been sent.')
        setTimeout(() => {
          Router.push('/thank-you')
        }, 2000)
      } else {
        setLoading(false)
        const objres = {
          result: 'message',
        }
        setErrorMesg(objres.result)
      }
    } catch (error) {
      setLoading(false)
      setErrorMesg('Please try again after sometime')
    }
  }
  const fetchIpLocation = () => {
    ;(async () => {
      await axios.get(`https://ipapi.co/json/`).then((response) => {
        setPhoneCountryCode(response.data.country_code)
        setFromCountryName(response.data.country_name)
      })
    })()
  }

  useEffect(() => {
    fetchIpLocation()
  }, [])

  return (
    <section className="contactus_section_azure">
      <Container fluid>
        <Row className="justify-content-start">
          <Col xl={12} className="bg-white form_block_azure">
            {data?.title ? (
              <TitleH2 className="mb-2 text_black" text={data?.title} />
            ) : (
              <TitleH2 className="mb-2 text_black" text="Hi! Ping Us" />
            )}
            {data?.subTitle ? (
              <SubText className="mb-2" text={data?.subTitle} />
            ) : (
              <SubText
                className="mb-2"
                text="Contacting us is the first step towards success."
              />
            )}

            <div className="mt-4">
              <form onSubmit={handleSubmit(onSubmit)}>
                <div className="d-flex" />
                <Row>
                  <Col xl={6} className="mb-2">
                    <Form.Group className="mb-3">
                      <Form.Control
                        type="text"
                        placeholder="Your Name *"
                        {...register('yourName')}
                      />
                      <p className="alert-error">
                        {errors.yourName && (
                          <span>{errors.yourName.message}</span>
                        )}
                      </p>
                    </Form.Group>
                  </Col>
                  <Col xl={6} className="mb-2">
                    <Form.Group className="mb-3">
                      <Controller
                        name="phoneInput"
                        control={control}
                        render={({ field: { onChange, value } }) => (
                          <PhoneInput
                            value={value}
                            onChange={(e: any) => onChange(e)}
                            defaultCountry={phoneCountryCode}
                            id="phoneInput"
                            className="form-control d-flex"
                            placeholder="Contact Number"
                          />
                        )}
                      />
                      <p className="alert-error">
                        {errors.phoneInput && (
                          <span>{errors.phoneInput.message}</span>
                        )}
                      </p>
                    </Form.Group>
                  </Col>
                  <Col xl={12} className="mb-2">
                    <Form.Group className="mb-3">
                      <Form.Control
                        type="text"
                        placeholder="Your Email *"
                        {...register('yourEmail')}
                      />
                      <p className="alert-error">
                        {errors.yourEmail && (
                          <span>{errors.yourEmail.message}</span>
                        )}
                      </p>
                    </Form.Group>
                  </Col>

                  <Col xl={12} className="mb-2 pt-3">
                    <Form.Control
                      as="textarea"
                      className="py-0"
                      placeholder="Project Requirements *"
                      {...register('projectRequirements')}
                      rows={4}
                    />
                    <p className="alert-error">
                      {errors.projectRequirements && (
                        <span>{errors.projectRequirements.message}</span>
                      )}
                    </p>
                  </Col>
                  {/* <Col xl={12} className="mt-1">
                    <Form.Group className="pb-1 d-none"></Form.Group>
                  </Col> */}
                  <Col xl={12} className="mt-2">
                    <Form.Group className="pb-4">
                      <div className="d-flex">
                        <span className="me-2">
                          <img
                            src="/assets/images/secure-icon.svg"
                            width={20}
                            height={20}
                            alt="secure-icon"
                          />
                        </span>
                        <span className="form-check-label">
                          We respect your privacy and do not tolerate spam and
                          will never sell rent lease or give away your
                          information (name, address, email, etc) to any third
                          party. Nor will we send you unsolicited email
                        </span>
                      </div>
                    </Form.Group>
                  </Col>
                  <Col xl={12} className="mt-4">
                    <div className="sub-btn-azzure">
                      <Button
                        className="wpcf7-form-control wpcf7-submit px-5 rounded-4px d-flex align-items-center h-50px btn btn-gradient btn-def"
                        type="submit"
                      >
                        Submit
                      </Button>
                    </div>
                    {Loading && (
                      <Spinner
                        className="ms-3"
                        animation="border"
                        variant="light"
                        role="status"
                        size="sm"
                      />
                    )}
                  </Col>
                  <p className="text_para pt-2 pe-0 pe-xl-5 me-0 me-lg-5 alert-successfully">
                    {SuccessMesg}
                  </p>
                  <p className="text_para pt-2 pe-0 pe-xl-5 me-0 me-lg-5 alert-error">
                    {ErrorMesg}
                  </p>
                </Row>
              </form>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  )
}

export default ContactUsAzureSection
